import { Component, OnInit, NgZone } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AccountService } from '../../Utils/_services/account/account.service';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';
import { ICustomError } from '../../Utils/_models/network-response';
import { IForgotPassword_Request, ICurrentUser } from '../../Utils/_services/account/account.model';
import { LeftUiComponent } from '../left-ui/left-ui/left-ui.component';

@Component({
  selector: 'app-forgot',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, LeftUiComponent],
  templateUrl: './forgot.component.html',
  styleUrl: './forgot.component.css'
})
export class ForgotComponent implements OnInit {

  public forgotModel: IForgotPassword_Request = {
    usernameOrEmail: ''
  };
  public isLoading = false;
  public showPassword = false;
  public errorMessage = '';
  public rememberMe = false;

  constructor(
    private accountService: AccountService,
    private router: Router,
    private toastr: ToastrService,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    this.accountService.currentUser$.pipe(take(1)).subscribe((currentUser: ICurrentUser | null) => {
      console.log("currentUser - ", currentUser);
      if (currentUser) {
        const redirectUrl = this.getRedirectUrlByRole(currentUser.role);
        this.ngZone.run(() => {
          this.router.navigate([redirectUrl]);
        });
        return;
      }
    });

    const savedCredentials = localStorage.getItem('rememberedCredentials');
    if (savedCredentials) {
      const credentials = JSON.parse(savedCredentials);
      this.forgotModel.usernameOrEmail = credentials.usernameOrEmail;
      this.rememberMe = true;
    }
  }

  onSubmit(): void {
    if (this.isLoading) return;

    if (!this.forgotModel.usernameOrEmail) {
      this.errorMessage = 'Please enter both username or email.';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    this.accountService.forgot({ usernameOrEmail: this.forgotModel.usernameOrEmail })
      .subscribe({
        next: (response) => {
          this.isLoading = false;

          if (response.data.emailSent) {
            this.toastr.info(response.msg);
            this.ngZone.run(() => {
              this.router.navigate(["/auth/login"]);
            });
          }
        },
        error: (err: ICustomError) => {
          this.isLoading = false;
          this.errorMessage = err.error?.msg || 'Forgot Password failed. Please check your username or email.';
          this.toastr.error(this.errorMessage);
          console.error('Login error:', err);
        }
      })

  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  navigateToRegister(): void {
    this.ngZone.run(() => {
      this.router.navigate(['/auth/register']);
    });
  }

  navigateToLogin(): void {
    this.ngZone.run(() => {
      this.router.navigate(["/auth/login"]);
    });
  }

  clearError(): void {
    this.errorMessage = '';
  }

  private getRedirectUrlByRole(role?: string): string {
    if (role && (role.toLowerCase() === 'admin' || role.toLowerCase() === 'administrator')) {
      return '/admin/dashboard';
    }
    return '/';
  }
}
